module.exports = __webpack_public_path__ + "static/assets/cd2fa6465953012247b14e89f4931cf9.svg";